'use strict';
// Check to see if the hero banner is overflowing for a11y purposes and is so, add class to adjust layout so all text is legible
var heroBanner = {
    init: function () {
        if ($('.js-hero-banner-content').outerHeight() > $('.js-hero-banner').outerHeight()) {
            $('.js-hero-banner').addClass('c-hero-banner--has-overflow');
        }
    }
};
module.exports = heroBanner;
